module.exports = __webpack_public_path__ + "img/3.161f51b8.png";